// import components below
import PageHeaderUI from 'components/UI/PageHeaderUI';

// main component
const EditPatientProfileHeader = () => {
  return (
    <div className='editPatientProfileHeader'>
      <PageHeaderUI>
        <h4>Admission Module</h4>
        <p>Dashboard / Admission / Edit Patient Profile</p>
      </PageHeaderUI>
    </div>
  );
};

export default EditPatientProfileHeader;
